export default __webpack_public_path__ + "static/media/search-up.bf62fbaf.svg";